import React, { useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { NoAlerts } from '../NoAlerts';
import { DeviationAlertDetails } from './DeviationAlertDetails';
import { Warning } from '../../../Warning/Warning';
import { useModal } from '@topconagriculture/modal';
import { useTranslation } from 'react-i18next';
import { WidgetFooter } from '../../WidgetFooter';
import { Loader } from '@topconagriculture/loader';
import { deviationGeneralAlertsModalName } from '../DeviationWidget';
import { useDeviationAlertsSummarySubscription } from '../hooks/useDeviationAlertsSummarySubscription';
const useStyles = makeStyles(() => ({
    container: { display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 20, height: '100%' },
    capitalized: { textTransform: 'capitalize' },
}));
export const DeviationWidgetS = ({ link, widget }) => {
    const classes = useStyles();
    const { data, isLoading } = useDeviationAlertsSummarySubscription(widget.type);
    const { dispatchOpenModal } = useModal();
    const { t } = useTranslation();
    const openModal = useCallback(() => dispatchOpenModal({
        modalName: deviationGeneralAlertsModalName,
        modalParams: { link, widget },
        modalOptions: {
            modalDialogProps: {
                maxWidth: 'xl',
            },
        },
    }), []);
    return (React.createElement(React.Fragment, null,
        isLoading ? (React.createElement(Loader, null)) : !!(data === null || data === void 0 ? void 0 : data.totalCount) ? (React.createElement("div", { className: classes.container },
            React.createElement("div", { className: classes.capitalized },
                React.createElement(Warning, { diameter: 90, color: "#E46A68", amount: data.totalCount, fontSize: 28, onClick: openModal, title: t('widget:alerts') })),
            React.createElement(DeviationAlertDetails, { onCLick: openModal, widgetType: widget.type }))) : (React.createElement(NoAlerts, { widgetType: widget.type })),
        React.createElement(WidgetFooter, { link: link, viewMoreButtonIsDisabled: false })));
};
//# sourceMappingURL=DeviationWidgetS.js.map